import { Layout } from 'antd';
import { CustomLayoutProps } from '../../../interfaces';
import './styles.scss';

const { Content } = Layout;

const MobileLayout: React.FC<CustomLayoutProps> = props => {
  const { children, header } = props;

  return (
    <div className="mobile-layout">
      <div className="mobile-layout-content">
        <Content>{children}</Content>
      </div>
      {header}
    </div>
  );
};

export default MobileLayout;
